import React, { Component } from 'react';

import Selection from './0-Home/Selection';
import Diagnostic from './0-Home/Diagnostic';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manual_mode: false,
      step: "selection",
      error: null,
      isLoaded: false,
      selected: false,
      territory: null
    };
  }

  loadTerritory = (title, geo_codes, zones) => {
    let myHeaders = new Headers()
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    let bodyRequest = JSON.stringify({
      title: title,
      geo_codes: geo_codes,
      zones: zones
    })


    this.setState({
      step: "loading"
    })

    fetch("http://127.0.0.1:5000/territory",
        {
          method: "POST",
          headers: myHeaders,
          body: bodyRequest,
        }
     ).then(res => res.json())
      .then(
        (result) => {
          console.log(result)
          this.setState({
            territory: result,
            step: "diagnostic_loaded"
          })
        },
        (error) => {
          this.setState({
            error: error,
            step: "error"
          })
        }
      )
  }

  componentDidMount() {
    //fetch("http://127.0.0.1:5000/api")
    fetch("territory.json")
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            territory: result
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render() {
    const {manual_mode, step, error, isLoaded, selected, territory } = this.state;
    if (manual_mode){
      if (error) {
        return <div>Erreur : {error.message}</div>;
      } else if (!isLoaded) {
        return <div><p>Chargement…</p></div>;
      } else {
        return (
          <Diagnostic territory={territory}/>
        );
      }
    }
    else{
      if (step == "selection") return <Selection loadTerritory={this.loadTerritory}/>
      else if (step =="loading") return <div><p>Chargement et calcul des données du territoire d'étude…</p></div>
      else if (step =="diagnostic_loaded") return <Diagnostic territory={territory}/>
      else return <div>Une erreur est survenue… ({error})</div>
    }
  }
}

export default App;
